
import { useState, useEffect } from "react";
import { API_ENDPOINTS } from "../api";
import { Card, CardHeader, Modal, ModalBody, ModalHeader, Table, Row, Alert, CardBody, Input, FormGroup, Col, } from "reactstrap";
import { buscarDB } from "service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faEdit, faEye, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import fileDownload from "js-file-download";
import { eliminarDB } from "service";
import { editDB } from "service";
import { InputUsuario, Select1, ComponenteCheck, CabeceraFormulariosTratamientoLista, ComponenteInputBuscar_, CabeceraFormulariosTratamiento } from "../input/elementos";
import { INPUT } from "Auth/config";
import toast from "react-hot-toast";
import { start } from "service";
import { saveDB } from "service";
import { diagnosticoPDF } from "pdfMake/diagnostico";

export default function Diagnostico() {
    const [inputBuscar, setInputBuscar] = useState({ campo: null, valido: null })

    const [listaDiagnostico, setListaDiagnostico] = useState([])  // LISTA DE DIAGNOSTICOS OSLICITADOS|
    const [pacienteData, setPacienteData] = useState([])  // datos del paciente
    const [listaItemsLaboratorioData, setListaItemsLaboratorioData] = useState([])  // lista para mostrar examenes seleccionados
    const [listaItemsLaboratorioAdmitidos, setListaItemsLaboratorioAdmitidos] = useState([]) // // lista para examenes seleccionados tickeados
    const [listaItemsLaboratorio, setListaItemsLaboratorio] = useState([]) // items laboratorio diagnostico 

    const [listaLaboratorio, setListaLaboratorio] = useState([])
    const [listaGrupo, setListaGrupo] = useState([])
    const [listaGrupoEtario, setListaGrupoEtario] = useState([])   


    const [modalRegistrar, setModalRegistrar] = useState(false)
    const [modalEdit, setModalEdit] = useState(false)


    const [id, setId] = useState({ campo: null, valido: null })
    const [presuntivo, setPresuntivo] = useState({ campo: null, valido: null })


    const [idPaciente, setIdPaciente] = useState({ campo: null, valido: null });
    const [nombrePaciente, setNombrePaciente] = useState({ campo: null, valido: null });
    const [fechaSolicitud, setFechaSolicitud] = useState({ campo: new Date().toISOString().split('T')[0], valido: 'true' });

    const [edad, setEdad] = useState({ campo: 0, valido: 'true' });

    const [idLaboratorio, setIdLaboratorio] = useState({ campo: null, valido: null });
    const [laboratorio, setLaboratorio] = useState({ campo: null, valido: null });
    const [idGrupo, setIdGrupo] = useState({ campo: null, valido: null });
    const [grupo, setGrupo] = useState({ campo: null, valido: null });
    const [idGrupoEtario, setIdGrupoEtario] = useState({ campo: null, valido: null });
    const [grupoEtario, setGrupoEtario] = useState({ campo: null, valido: null });

    const [idPreQuirurgico, setIdPreQuirurgico] = useState({ campo: null, valido: null });
    const [preQuirurgico, setPreQuirurgico] = useState({ campo: null, valido: null });
    const [idPostTratamiento, setIdPostTratamiento] = useState({ campo: null, valido: null });
    const [postTratamiento, setPostTratamiento] = useState({ campo: null, valido: null });
    const [codigo, setCodigo] = useState({ campo: null, valido: null });
    const [fechaNac, setFechaNac] = useState({ campo: null, valido: null });

    const [estadoEnvio, setEstadoEnvio] = useState(0);

    useEffect(() => {
        document.title = 'DIAGNOSTICOS'
        if (inputBuscar.campo?.length === 0) listar()
    }, [inputBuscar])



    useEffect(() => {
        listar()
    }, [])


    const initialFormState = {
        campo: null,
        valido: null
    };


    const vaciarDatos = () => {
        const fieldsToReset = {
            setId,
            setPreQuirurgico,

        };
        Object.values(fieldsToReset).forEach(setterFn => {
            setterFn(initialFormState);
        });
        setListaItemsLaboratorioAdmitidos([])

        setModalEdit(false);
        setModalRegistrar(false);
    };

    const listar = async () => {
        const data = await buscarDB(API_ENDPOINTS.DIAGNOSTICO.LISTAR,);
        setListaDiagnostico(data)

    }
    const buscar = async () => {
        if (inputBuscar.valido === "true") {
            const data = await buscarDB(API_ENDPOINTS.DIAGNOSTICO.BUSCAR, { dato: inputBuscar.campo })
            if (data.length == 0) toast.error("No se encontraron registros")

            setListaDiagnostico(data)
        }
    }


    const listarParametros = async (edicion, codigo) => {

        const loadingToast = toast.loading('Cargando información...');
        const data = await start(API_ENDPOINTS.DIAGNOSTICO.LISTAR_PARAMETROS, { codigo })
        toast.dismiss(loadingToast);


        if (data[0]?.length > 0) {
            setListaGrupo(data[0])
        }
        if (data[1]?.length > 0) {
            setListaItemsLaboratorio(data[1])
        }
        if (data[2]?.length > 0) {
            for (let element of data[2]) {
                listaItemsLaboratorioAdmitidos.push(element.id_items_diagnostico)
            };
            setListaItemsLaboratorioData(data[2])
        }
        if (data[3]?.length > 0) {
            setPacienteData(data[3])
        }

        if (data[4]?.length > 0) {
            setListaLaboratorio(data[4])
        }
        if (edicion == 1) {
            setModalRegistrar(true)
        }
        if (edicion == 2) {
            setModalEdit(true)
        }
    }

    const listarGruposEtarios = async (id_grupo) => {

        const loadingToast = toast.loading('Cargando información...');
        const data = await start(API_ENDPOINTS.DIAGNOSTICO.LISTAR_GRUPO_ETARIO_REPORTES, { id_grupo })
        toast.dismiss(loadingToast);
        setListaGrupoEtario(data)

    }




    const insertar = async () => {
        const loadingToast = toast.loading('Registrando información...');
        // await funcionesPreEnvio()


        let edad_años = 0
        let edad_meses = 0
        let edad_dias = 0

        let edadBD = pacienteData.find(e => idPaciente.campo == e.value)?.fecha_nac
        let hoy = new Date();
        let fechaDeNacimiento = new Date(edadBD);
        edad_años = hoy.getFullYear() - fechaDeNacimiento.getFullYear();;
        edad_meses = hoy.getMonth() - fechaDeNacimiento.getMonth();
        edad_dias = hoy.getDate() - fechaDeNacimiento.getDate();

        if (edad_dias < 0) {
            const mesAnterior = new Date(hoy.getFullYear(), hoy.getMonth(), 0);
            edad_dias += mesAnterior.getDate();
            edad_meses--;
        }

        if (edad_meses < 0) {
            edad_años--;
            edad_meses += 12;
        }

        let listaFinalAdmitidos = []
        for (let i = 0; i < listaItemsLaboratorio.length; i++) {
            for (let j = 0; j < listaItemsLaboratorioAdmitidos.length; j++) {
                if (listaItemsLaboratorio[i].value == listaItemsLaboratorioAdmitidos[j]) {
                    listaFinalAdmitidos.push({ value: listaItemsLaboratorio[i].value, label: listaItemsLaboratorio[i].label })
                }
            }
        }


        if (estadoEnvio === 0) {
            setEstadoEnvio(1);
            await saveDB(API_ENDPOINTS.DIAGNOSTICO.REGISTRAR, {
                fecha_solicitud: fechaSolicitud.campo,
                // id_grupo: idGrupo.campo,
                // grupo: grupo.campo,
                // id_grupo_etario: idGrupoEtario.campo,
                // grupo_etario: grupoEtario.campo,
                edad_años,
                edad_meses,
                edad_dias,
                sexo: pacienteData.find(e => idPaciente.campo == e.value)?.sexo,
                id_pre_quirurgico: idPreQuirurgico.campo,
                pre_quirurgico: preQuirurgico.campo,
                id_post_tratamiento: idPostTratamiento.campo,
                post_tratamiento: postTratamiento.campo,
                id_paciente: idPaciente.campo,
                paciente: nombrePaciente.campo,
                listaFinalAdmitidos,
                presuntivo: presuntivo.campo,
                id_laboratorio: idLaboratorio.campo,
                laboratorio: laboratorio.campo
            }, setModalRegistrar, setEstadoEnvio, false, vaciarDatos)
            toast.dismiss(loadingToast);
            listar()

        } else toast.error("Por favor complete todos los campos requeridos antes de continuar");
    };

    const editar = async () => {
        const loadingToast = toast.loading('Actualizando información...');
        let listaFinalAdmitidos = []
        for (let i = 0; i < listaItemsLaboratorio.length; i++) {
            for (let j = 0; j < listaItemsLaboratorioAdmitidos.length; j++) {
                if (listaItemsLaboratorio[i].value == listaItemsLaboratorioAdmitidos[j]) {
                    listaFinalAdmitidos.push({ value: listaItemsLaboratorio[i].value, label: listaItemsLaboratorio[i].label })
                }
            }
        }

        let edad_años = 0
        let edad_meses = 0
        let edad_dias = 0


        let edadBD = pacienteData.find(e => idPaciente.campo == e.value)?.fecha_nac
        let hoy = new Date();
        let fechaDeNacimiento = new Date(edadBD);
        edad_años = hoy.getFullYear() - fechaDeNacimiento.getFullYear();;
        edad_meses = hoy.getMonth() - fechaDeNacimiento.getMonth();
        edad_dias = hoy.getDate() - fechaDeNacimiento.getDate();

        if (edad_dias < 0) {
            const mesAnterior = new Date(hoy.getFullYear(), hoy.getMonth(), 0);
            edad_dias += mesAnterior.getDate();
            edad_meses--;
        }

        if (edad_meses < 0) {
            edad_años--;
            edad_meses += 12;
        }
        await editDB(API_ENDPOINTS.DIAGNOSTICO.MODIFICAR, {
            // id: id.campo,
            fecha_solicitud: fechaSolicitud.campo,
            // id_grupo: idGrupo.campo,
            // grupo: grupo.campo,
            // id_grupo_etario: idGrupoEtario.campo,
            // grupo_etario: grupoEtario.campo,
            edad_años,
            edad_meses,
            edad_dias,
            sexo: pacienteData.find(e => idPaciente.campo == e.value)?.sexo,
            id_pre_quirurgico: idPreQuirurgico.campo,
            pre_quirurgico: preQuirurgico.campo,
            id_post_tratamiento: idPostTratamiento.campo,
            post_tratamiento: postTratamiento.campo,
            id_paciente: idPaciente.campo,
            paciente: nombrePaciente.campo,
            codigo: codigo.campo,
            id_laboratorio: idLaboratorio.campo,
            laboratorio: laboratorio.campo,
            listaFinalAdmitidos,
            presuntivo: presuntivo.campo

        }, setModalEdit, false, vaciarDatos)
        toast.dismiss(loadingToast);
        listar()
    };


    const eliminar = async (codigo) => {
        if (window.confirm('Eliminar Consulta ?')) {
            await eliminarDB(API_ENDPOINTS.DIAGNOSTICO.ELIMINAR, { codigo })
            listar()
        }
    }
    const exportPdf = async (output, codigo, paciente) => {
        const data = await start(API_ENDPOINTS.DIAGNOSTICO.VER_PDF, { codigo, paciente })

        if (!data[1][0]?.fecha_toma_muestra) {
            toast.error('Todavia no se asignaron resutados')
            return
        }
        const response = await diagnosticoPDF(output, { paciente: data[0], listaItemsLaboratorio: data[1] })

        if (!response?.success) {
            alert(response?.message);
            return;
        }

        if (output === "b64") {
            const b64toBlob = (
                b64Data,
                contentType = "",
                sliceSize = 512
            ) => {
                const byteCharacters = atob(b64Data);
                const byteArrays = [];

                for (
                    let offset = 0;
                    offset < byteCharacters.length;
                    offset += sliceSize
                ) {
                    const slice = byteCharacters.slice(
                        offset,
                        offset + sliceSize
                    );

                    const byteNumbers = new Array(slice.length);
                    for (let i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }

                    const byteArray = new Uint8Array(byteNumbers);
                    byteArrays.push(byteArray);
                }

                const blob = new Blob(byteArrays, { type: contentType });
                return blob;
            };
            const blob = b64toBlob(response.content, "application/pdf");
            fileDownload(blob, "diagnostico" + data[0][0].nombre + ' ' + data[0][0].ap1 + ' ' + new Date().toLocaleDateString() + ".pdf");
        }
    }


   


    return <>
        <div className="contentSimple" >
            <div className="main-container">

                <Card>
                    <CabeceraFormulariosTratamientoLista text={"LISTA DE DIAGNOSTICOS PARA CHAGAS"} />
                    <CardBody style={{ paddingTop: "5px" }}>
                        <div style={{ display: 'flex', justifyContent: 'end' }}>
                            <button className='btn-new-transparent' pb={3} onClick={() => { setModalRegistrar(true); listarParametros(1, null) }}>
                                Registrar
                            </button >
                        </div>
                        <div className="pt-2 pl-0">
                            <ComponenteInputBuscar_
                                estado={inputBuscar}
                                cambiarEstado={setInputBuscar}
                                name="inputBuscar"
                                ExpresionRegular={INPUT.INPUT_BUSCAR}  //expresion regular
                                placeholder="Escriba para filtrar ..."
                                eventoBoton={buscar}
                                etiqueta={'Buscar'}
                            />
                        </div>

                        <Table className="tablesorter" responsive >
                            <thead className="text-primary">
                                <tr>
                                    <th >PACIENTE</th>
                                    <th >APELLIDO PATERNO</th>
                                    <th >APELLIDO MATERNO</th>
                                    <th >C.I.</th>
                                    <th >FECHA SOLICITUD</th>
                                    <th >EST. SOLICITANTE</th>
                                    <th >MEDICO SOLICITANTE</th>
                                    <th >LABORATORIO</th>
                                    <th >LABORATORISTA</th>
                                    <th ></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody >
                                {listaDiagnostico.map((a, index) => (
                                    <tr key={a.id} className='item' style={{
                                        background: index % 2 == 0 ? "#E1EEF4" : 'white',
                                        borderLeft: a.conclusion ? '5px solid #00AEA4' : '5px solid #fd5d93'
                                    }}>

                                        <td><div className="tbl-des ">{a.nombre}</div></td>
                                        <td><div className="tbl-des ">{a.ap1}</div></td>
                                        <td><div className="tbl-des ">{a.ap2}</div></td>
                                        <td><div className="tbl-des tbl-bold">{a.ci}</div></td>
                                        <td><div className="tbl-des ">{a.fecha_solicitud}</div></td>

                                        <td>
                                            <div className="tbl-name ">{a.hospital}</div>
                                            <div className="tbl-des">{a.municipio_hospital}</div>
                                        </td>
                                        <td>
                                            <div className="tbl-des ">{a.medico_solicitante}</div>
                                        </td>
                                        <td>
                                            <div className="tbl-name ">{a.laboratorio}</div>
                                            <div className="tbl-des">{a.municipio_laboratorio}</div>
                                        </td>
                                        <td>
                                            <div className="tbl-name ">{a.medico_laboratorio}</div>
                                        </td>
                                        <td>

                                            {a.medico_laboratorio ? <FontAwesomeIcon style={{ color: 'rgb(125, 160, 90)' }} icon={faCheckCircle} /> :
                                                <FontAwesomeIcon style={{ color: '#f5365c' }} icon={null} />}

                                        </td>
                                        <td>
                                            <div className="btn-tbl-container row">

                                                {a.edicion && a.sin_resultado ?
                                                    <>
                                                        <div
                                                            className="btn-tbl col-3 bg-info"
                                                            onClick={() => {
                                                                setIdPaciente({ campo: a.id_paciente, valido: 'true' })
                                                                setNombrePaciente({ campo: a.nombre_paciente, valido: 'true' })
                                                                setIdGrupoEtario({ campo: a.id_grupo_etario, valido: true })
                                                                setGrupoEtario({ campo: a.grupo_etario, valido: true })
                                                                setIdGrupo({ campo: a.id_grupo, valido: true })
                                                                setGrupo({ campo: a.grupo, valido: true })
                                                                listarGruposEtarios(a.id_grupo)
                                                                setEdad({ campo: a.edad, valido: true })
                                                                setIdPreQuirurgico({ campo: a.id_pre_quirurgico, valido: true })
                                                                setPreQuirurgico({ campo: a.pre_quirurgico, valido: true })
                                                                setIdPostTratamiento({ campo: a.id_post_tratamiento, valido: true })
                                                                setPostTratamiento({ campo: a.post_tratamiento, valido: true })
                                                                setId({ campo: a.id_diagnostico, valido: true })
                                                                listarParametros(2, a.codigo)
                                                                setCodigo({ campo: a.codigo, valido: true })
                                                                setPresuntivo({ campo: a.presuntivo, valido: true })
                                                                setIdLaboratorio({ campo: a.id_laboratorio, valido: true })
                                                                setLaboratorio({ campo: a.laboratorio, valido: true })
                                                                setFechaNac({ campo: a.fecha_nacimiento, valido: true })

                                                            }}
                                                        ><FontAwesomeIcon icon={faEdit}></FontAwesomeIcon></div>
                                                        <div
                                                            onClick={() => { eliminar(a.codigo) }}
                                                            className="btn-tbl col-3  ml-1" style={{ background: '#FF3D85' }}><FontAwesomeIcon icon={faTrashAlt}></FontAwesomeIcon>
                                                        </div>
                                                    </> : null
                                                }

                                                {!a.sin_resultado > 0 ?
                                                    < div onClick={() => exportPdf(window.innerWidth < 1100 ? 'b64' : "print", a.codigo, a.id_paciente)}
                                                        className="btn-tbl btn-success col-3  ml-1 " style={{ background: '#00d084' }} ><FontAwesomeIcon icon={faEye}></FontAwesomeIcon></div> : null}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>


                        <div style={{ padding: '1rem' }}>
                            {listaDiagnostico.length + " Registro(s)"}
                        </div>
                    </CardBody>
                </Card>

            </div>
        </div>





        <Modal
            isOpen={modalRegistrar}
            toggle={() => { setModalRegistrar(!modalRegistrar); vaciarDatos() }}
            className="modal-lgmd"
        >
            <ModalHeader
                toggle={() => { setModalRegistrar(!modalRegistrar); vaciarDatos() }}
            >
            </ModalHeader>
            <ModalBody >
                <CabeceraFormulariosTratamiento text={'NUEVA SOLICITUD LABORATORIO'} />
                <div className='cabecera-form mt-3'  >
                    <p>DATOS DEL PACIENTE</p>
                </div>
                <Row className='mb-3'>
                    <Col md={4}>
                        <Select1
                            estado={idPaciente}
                            cambiarEstado={setIdPaciente}
                            ExpresionRegular={INPUT.ID}
                            etiqueta={'Paciente'}
                            msg={"el formato no es valido"}
                            lista={pacienteData}
                            name={'id_paciente'}
                            label={setNombrePaciente}
                        />
                    </Col>

                    <Col md={3}>
                        <FormGroup>
                            <label style={{ marginBottom: '0', fontSize: '11px', fontWeight: 'bold' }}>
                                {'Paciente'}
                            </label>
                            <Input
                                type="text"
                                value={pacienteData.find(e => idPaciente.campo == e.value)?.label?.split('-')[0] || ""}
                                valido={null}
                                placeholder={'PACIENTE'}
                                toUpperCase
                                disabled
                            />
                        </FormGroup>
                    </Col>
                    <Col md={3}>
                        <FormGroup>
                            <label style={{ marginBottom: '0', fontSize: '11px', fontWeight: 'bold' }}>
                                {'Cédula de identidad'}
                            </label>
                            <Input
                                type="text"
                                value={pacienteData.find(e => idPaciente.campo == e.value)?.ci || ""}
                                valido={null}
                                placeholder={'C.I.'}
                                toUpperCase
                                disabled
                            />
                        </FormGroup>
                    </Col>

                    <Col md={2}>
                        <FormGroup>
                            <label style={{ marginBottom: '0', fontSize: '11px', fontWeight: 'bold' }}>
                                {'fecha Nacimiento'}
                            </label>
                            <Input
                                type="text"
                                value={pacienteData.find(e => idPaciente.campo == e.value)?.fecha_nac || ""}
                                valido={null}
                                placeholder={'FECHA NACIMIENTO'}
                                toUpperCase
                                disabled
                            />
                        </FormGroup>
                    </Col>

                 
                </ Row>


                <div className='cabecera-form mt-0'  >
                    <p>DATOS DE LA SOLICITUD</p>
                </div>
                <Row>
                    <Col md={5}>
                        <InputUsuario
                            estado={fechaSolicitud}
                            name={'fecha_solicitud'}
                            tipo="date"
                            cambiarEstado={setFechaSolicitud}
                            ExpresionRegular={INPUT.DATE}
                            etiqueta={'Fecha Solicitud'}
                            msg={"el formato no es valido"}
                        />
                    </Col>
                    <Col md={7}>
                        <InputUsuario
                            estado={presuntivo}
                            name={'presuntivo'}
                            cambiarEstado={setPresuntivo}
                            ExpresionRegular={INPUT.TEXT}
                            etiqueta={'Diagnostico Presuntivo'}
                            msg={"el formato no es valido"}
                        />
                    </Col>
                </Row>



                <div className="col-12">
                    <fieldset className="border p-" style={{
                        borderRadius: '6px',
                        borderColor: '#dee2e6',
                        backgroundColor: 'white',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                    }}>
                        <legend
                            className="float-none w-auto px-3 py-2"
                            style={{
                                fontSize: "15px",
                                fontWeight: '600',
                                color: '#495057',
                                marginBottom: '0'
                            }}
                        >
                            SOLICITUD DE EXAMENES COMPLEMENTARIOS
                        </legend>
                        <div className="row g-3 p-2">
                            {
                                listaItemsLaboratorio.map((e, index) => (< div key={e.value} style={{ marginLeft: '30px' }}>
                                    <ComponenteCheck
                                        key={index}
                                        id={e.value}
                                        item={e.label}
                                        admitidos={listaItemsLaboratorioAdmitidos}
                                    />
                                    <span style={{ marginRight: '1rem' }}></span>
                                </div>
                                ))
                            }
                        </div>
                    </fieldset>
                </div>
                <Row>
                    <div className="col-md-3" style={{ marginBottom: '.7rem' }}>
                        <Select1
                            estado={idPostTratamiento}
                            cambiarEstado={setIdPostTratamiento}
                            ExpresionRegular={INPUT.ID}
                            etiqueta={'Confirmacion de diagnosticos'}
                            msg={"el formato no es valido"}
                            lista={[{ value: 1, label: 'PRE TRATAMIENTO' }, { value: 2, label: 'POST TRATAMIENTO' }]}
                            name={'id_post_tratamiento'}
                            label={setPostTratamiento}
                        />
                    </div>

                    <div className="col-md-3" style={{ marginBottom: '.7rem' }}>
                        <Select1
                            estado={idPreQuirurgico}
                            cambiarEstado={setIdPreQuirurgico}
                            ExpresionRegular={INPUT.ID}
                            etiqueta={'Prequirurgico'}
                            msg={"el formato no es valido"}
                            lista={[{ value: 1, label: 'Si' }, { value: 2, label: 'No' }]}
                            name={'id_prequirurgico'}
                            label={setPreQuirurgico}
                            importante={false}
                        />
                    </div>

                    <div className="col-md-3" style={{ marginBottom: '.7rem' }}>
                        <Select1
                            estado={idLaboratorio}
                            cambiarEstado={setIdLaboratorio}
                            ExpresionRegular={INPUT.ID}
                            etiqueta={'Laboratorio'}
                            msg={"el formato no es valido"}
                            lista={listaLaboratorio}
                            name={'id_laboratorio'}
                            label={setLaboratorio}
                        // importante={false}
                        />
                    </div>
                </Row>
                <p style={{ color: '#f5365c', fontSize: '11px' }}> Todo paciente con dos pruebas serológicas positivos se considera para hacer tratamiento</p>
                <div style={{ display: 'flex', justifyContent: 'center', padding: '1px 0px' }} >
                    <div className="hero-section m-1 mt-3 mb-3" >
                        <button onClick={() => insertar()} className="btn btn-success" >Registrar</button>
                    </div>
                </div>
            </ModalBody>
        </Modal>


        <Modal
            isOpen={modalEdit}
            toggle={() => { setModalEdit(!modalEdit); vaciarDatos() }}
            className="modal-md"
        >
            <ModalHeader
                toggle={() => { setModalEdit(!modalEdit); vaciarDatos() }}
            >
            </ModalHeader>
            <ModalBody >

                <CabeceraFormulariosTratamiento text={'MODIFICAR SOLICITUD LABORATORIO'} />
                <div style={{ display: 'flex', justifyContent: 'end' }}>
                    <p style={{ fontStyle: 'italic', fontWeight: 'bold', marginBottom: '0', marginTop: '10px', fontSize: '12px', color: 'red' }}>{'CODIGO SOLICITUD: ' + codigo.campo}</p>
                </div>
                <div className='cabecera-form mt-0'  >
                    <p>DATOS DEL PACIENTE</p>
                </div>
                <Row className='mb-3'>
                    <Col md={4}>
                        <Select1
                            estado={idPaciente}
                            cambiarEstado={setIdPaciente}
                            ExpresionRegular={INPUT.ID}
                            etiqueta={'Paciente'}
                            msg={"el formato no es valido"}
                            lista={pacienteData}
                            name={'id_paciente'}
                            label={setNombrePaciente}
                            importante={true}
                            setIdGrupo={setIdGrupo}
                            setGrupo={setGrupo}
                            setIdGrupoEtario={setIdGrupoEtario}
                            setGrupoEtario={setGrupoEtario}
                            listaGrupo={listaGrupo}
                            listaGrupoEtario={listaGrupoEtario}
                        />
                    </Col>

                    <Col md={3}>
                        <FormGroup>
                            <label style={{ marginBottom: '0', fontSize: '11px', fontWeight: 'bold' }}>
                                {'Paciente'}
                            </label>
                            <Input
                                type="text"
                                value={pacienteData.find(e => idPaciente.campo == e.value)?.label?.split('-')[0] || ""}
                                valido={null}
                                placeholder={'PACIENTE'}
                                toUpperCase
                                disabled
                            />
                        </FormGroup>
                    </Col>
                    <Col md={3}>
                        <FormGroup>
                            <label style={{ marginBottom: '0', fontSize: '11px', fontWeight: 'bold' }}>
                                {'Cédula de identidad'}
                            </label>
                            <Input
                                type="text"
                                value={pacienteData.find(e => idPaciente.campo == e.value)?.ci || ""}
                                valido={null}
                                placeholder={'C.I.'}
                                toUpperCase
                                disabled
                            />
                        </FormGroup>
                    </Col>

                    <Col md={2}>
                        <FormGroup>
                            <label style={{ marginBottom: '0', fontSize: '11px', fontWeight: 'bold' }}>
                                {'fecha Nacimiento'}
                            </label>
                            <Input
                                type="text"
                                value={pacienteData.find(e => idPaciente.campo == e.value)?.fecha_nac || ""}
                                valido={null}
                                placeholder={'FECHA NACIMIENTO'}
                                toUpperCase
                                disabled
                            />
                        </FormGroup>
                    </Col>
            
                </ Row>


                <div className='cabecera-form mt-3'  >
                    <p>DATOS DE LA SOLICITUD</p>
                </div>

                <Row>
                    <Col md={5}>
                        <InputUsuario
                            estado={fechaSolicitud}
                            name={'fecha_solicitud'}
                            tipo="date"
                            cambiarEstado={setFechaSolicitud}
                            ExpresionRegular={INPUT.DATE}
                            etiqueta={'Fecha Solicitud'}
                            msg={"el formato no es valido"}
                        />
                    </Col>
                    <Col md={7}>
                        <InputUsuario
                            estado={presuntivo}
                            name={'presuntivo'}
                            cambiarEstado={setPresuntivo}
                            ExpresionRegular={INPUT.TEXT}
                            etiqueta={'Diagnostico Presuntivo'}
                            msg={"el formato no es valido"}
                        />
                    </Col>
                </Row>

                <div className="col-12">
                    <fieldset className="border p-" style={{
                        borderRadius: '6px',
                        borderColor: '#dee2e6',
                        backgroundColor: 'white',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                    }}>
                        <legend
                            className="float-none w-auto px-3 py-2"
                            style={{
                                fontSize: "15px",
                                fontWeight: '600',
                                color: '#495057',
                                marginBottom: '0'
                            }}
                        >
                            SOLICITUD DE EXAMENES COMPLEMENTARIOS
                        </legend>
                        <div className="row g-3 p-2">
                            {
                                listaItemsLaboratorio.map((e, index) => (< div key={e.value} style={{ marginLeft: '30px' }}>
                                    <ComponenteCheck
                                        key={index}
                                        id={e.value}
                                        item={e.label}
                                        admitidos={listaItemsLaboratorioAdmitidos}
                                    />
                                    <span style={{ marginRight: '1rem' }}></span>
                                </div>
                                ))
                            }
                        </div>
                    </fieldset>
                </div>
                <Row>
                    <div className="col-md-3" style={{ marginBottom: '.7rem' }}>
                        <Select1
                            estado={idPostTratamiento}
                            cambiarEstado={setIdPostTratamiento}
                            ExpresionRegular={INPUT.ID}
                            etiqueta={'Confirmacion de diagnosticos'}
                            msg={"el formato no es valido"}
                            lista={[{ value: 1, label: 'PRE TRATAMIENTO' }, { value: 2, label: 'POST TRATAMIENTO' }]}
                            name={'id_post_tratamiento'}
                            label={setPostTratamiento}
                        />
                    </div>

                    <div className="col-md-3" style={{ marginBottom: '.7rem' }}>
                        <Select1
                            estado={idPreQuirurgico}
                            cambiarEstado={setIdPreQuirurgico}
                            ExpresionRegular={INPUT.ID}
                            etiqueta={'Prequirurgico'}
                            msg={"el formato no es valido"}
                            lista={[{ value: 1, label: 'Si' }, { value: 2, label: 'No' }]}
                            name={'id_prequirurgico'}
                            label={setPreQuirurgico}
                            importante={false}
                        />
                    </div>

                    <div className="col-md-3" style={{ marginBottom: '.7rem' }}>
                        <Select1
                            estado={idLaboratorio}
                            cambiarEstado={setIdLaboratorio}
                            ExpresionRegular={INPUT.ID}
                            etiqueta={'Laboratorio'}
                            msg={"el formato no es valido"}
                            lista={listaLaboratorio}
                            name={'id_laboratorio'}
                            label={setLaboratorio}
                        // importante={false}
                        />
                    </div>
                </Row>
                <p style={{ color: 'red', textAlign: 'center' }}>Todo paciente con dos pruebas serológicas positivos se considera para hacer tratamiento</p>

                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: '1rem'
                }}>
                    <button
                        onClick={() => editar()}
                        className="btn btn-success"
                        style={{
                            padding: '0.5rem 1rem',
                            fontSize: '0.875rem',
                            fontWeight: '500',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                        }}
                    >
                        Editar
                    </button>
                </div>

            </ModalBody>
        </Modal>
     
    </>
}
